function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Applications");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "rgb(136, 145, 190)",
  d: "M0 8h8v-8h-8zM12 32h8v-8h-8zM0 32h8v-8h-8zM0 20h8v-8h-8zM12 20h8v-8h-8zM24 0v8h8v-8zM12 8h8v-8h-8zM24 20h8v-8h-8zM24 32h8v-8h-8z"
});

var SvgAppRectangleSolid = function SvgAppRectangleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/app-rectangle-solid.07d96d77.svg";
export { SvgAppRectangleSolid as ReactComponent };